(function () {
  const MOBILE_QUERY = '(max-width: 749px)';
  const SPLIT_TEXT_SELECTOR =
    '.text-image-overlap__heading, .text-image-overlap__text, .text-image-overlap__caption, .text-image-overlap__text :is(p, li, strong, em, span)';

  function clearMobileSplit(layout, copy) {
    layout.style.removeProperty('--tio-copy-height');

    if (!copy) return;

    copy.querySelectorAll(SPLIT_TEXT_SELECTOR).forEach((element) => {
      element.style.removeProperty('--tio-bg-offset');
    });
  }

  function syncMobileSplitText(layout) {
    const copy = layout.querySelector('.text-image-overlap__copy');
    if (!copy) return;

    if (!window.matchMedia(MOBILE_QUERY).matches) {
      clearMobileSplit(layout, copy);
      return;
    }

    const copyTop = copy.getBoundingClientRect().top;
    const copyHeight = copy.offsetHeight;

    layout.style.setProperty('--tio-copy-height', `${copyHeight}px`);

    copy.querySelectorAll(SPLIT_TEXT_SELECTOR).forEach((element) => {
      const offset = element.getBoundingClientRect().top - copyTop;
      element.style.setProperty('--tio-bg-offset', `${-offset}px`);
    });
  }

  function initLayout(layout) {
    if (!(layout instanceof HTMLElement) || layout.dataset.tioSplitInit === 'true') return;

    layout.dataset.tioSplitInit = 'true';

    const run = () => syncMobileSplitText(layout);
    run();

    const copy = layout.querySelector('.text-image-overlap__copy');

    if (copy && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(run);
      observer.observe(copy);

      const media = layout.querySelector('.text-image-overlap__media');
      if (media) observer.observe(media);
    }

    window.addEventListener('resize', run, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    }
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const layouts =
      scope === document
        ? document.querySelectorAll('.text-image-overlap__layout[id^="TextImageOverlap-"]')
        : scope.querySelectorAll('.text-image-overlap__layout[id^="TextImageOverlap-"]');

    layouts.forEach(initLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:reorder', () => initAll(document));
})();
